import React from 'react';
import { bool, func, object, oneOfType, shape, string } from 'prop-types';
import { connect } from 'react-redux';
import cn from 'classnames';
import { getIsDarkMode } from '../../redux/switcher/switcher';

const mapStateToProps = (state) => ({
  isDarkMode: getIsDarkMode(state),
});

const mapDispatchToProps = undefined;

function getSrcSet(data) {
  if (data['2x']) {
    return `${data['1x']}, ${data['2x']} 2x`;
  }
  return undefined;
}

function renderImage({ data, innerRef, ...rest }) {
  return (
    <img
      {...rest}
      ref={innerRef}
      className={cn(data.className, rest.className)}
      src={data['1x']}
      srcSet={getSrcSet(data)}
      alt={data.alt}
    />
  );
}

function Image(props) {
  const { isDarkMode, imgData, darkImgData, ...rest } = props;

  if (isDarkMode) {
    return renderImage({ data: darkImgData, ...rest });
  }
  return renderImage({ data: imgData, ...rest });
}

Image.propTypes = {
  isDarkMode: bool,
  imgData: shape({
    className: string,
    '1x': string.isRequired,
    '2x': string,
    alt: string.isRequired,
  }).isRequired,
  darkImgData: shape({
    className: string,
    '1x': string.isRequired,
    '2x': string,
    alt: string.isRequired,
  }),
  innerRef: oneOfType([func, object]),
  onLoad: func,
};

Image.defaultProps = {
  imgData: {},
  darkImgData: {},
};

export default connect(mapStateToProps, mapDispatchToProps)(Image);
